// DONE: ປະເພດ activity history
const convertTypeActivityHistory = (activityHistoryType) => {
  let response = activityHistoryType;
  switch (activityHistoryType) {
    case "UPDATE":
      response = (
        <div
          style={{
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 30,
            border: "1px solid #FF8A00",
            color: "#FF8A00",
            fontSize: 12,
            width: 60,
          }}
        >
          ແກ້ໄຂ
        </div>
      );
      break;
    case "DELETE":
      response = (
        <div
          style={{
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 30,
            border: "1px solid #CED4DA",
            color: "#CED4DA",
            fontSize: 12,
            width: 60,
          }}
        >
          ລຶບ
        </div>
      );
      break;
    case "CREATE":
      response = (
        <div
          style={{
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 30,
            border: "1px solid #0178C1",
            color: "#0178C1",
            fontSize: 12,
            width: 60,
          }}
        >
          ສ້າງ
        </div>
      );
      break;
    default:
    // code block
  }
  return response;
};

export default convertTypeActivityHistory;
